/**
 * ==============================================================================
 * Lady Milan - Product Card Controller
 * Handles video playback and media hover interactions
 * (Note: Dynamic Sibling Swatches archived in assets/lady-milan-card-product-backup-swatches.js)
 * ==============================================================================
 */

window.initLadyMilanProductCards = function() {
  const cards = document.querySelectorAll('.lm-product-card');

  cards.forEach(card => {
    // Avoid double initialization
    if (card.dataset.lmInitialized) return;
    card.dataset.lmInitialized = 'true';

    const video = card.querySelector('.lm-product-card-video');

    // Video playback handling
    if (video) {
      card.addEventListener('mouseenter', () => {
        video.play().catch(() => {});
      });
      card.addEventListener('mouseleave', () => {
        video.pause();
        video.currentTime = 0;
      });
    }
  });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', window.initLadyMilanProductCards);
} else {
  window.initLadyMilanProductCards();
}
